import React from "react";
import SCSMSDashboard from "./SCSMSDashboard";
import type { DashboardPageProps } from "./dashboard.types";

export default function SalesDashboard(props: DashboardPageProps) {
  return (
    <SCSMSDashboard
      {...props}
      dashboard="sales"
      title="Sales Dashboard"
      subtitle="Monitor quotations, active orders, payments, follow-ups, targets, and pipeline value."
    />
  );
}
